import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { InsideSection } from '../components/sales/InsideSection';
import { PainSection } from '../components/sales/PainSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { VisualSection } from '../components/sales/VisualSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { BeforeAfterSection } from '../components/sales/BeforeAfterSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { OfferSection } from '../components/sales/OfferSection';
import { OnePartSection } from '../components/sales/OnePartSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalSection } from '../components/sales/FinalSection';
import { SiteFooter } from '../components/sales/SiteFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-214" data-mp="3vp4k854585go">
      <header className="border-b border-brand-charcoal/10 bg-brand-charcoal" data-id="element-215" data-mp="35t02xb90jwaj">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-216" data-mp="35qx4q3xpiwuq">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-217" data-mp="30ru8n8zpg0yw">
            Barber Instructor Ready™ · Édition française
          </p>
        </div>
      </header>

      <main data-id="element-218" data-mp="3tghwncbu94g5">
        <HeroSection data-id="element-219" data-mp="3ojhsx82gods7" />
        <InsideSection data-id="element-220" data-mp="3oizqtut4b5cd" />
        <PainSection data-id="element-221" data-mp="3oksx38ztjnju" />
        <SolutionSection data-id="element-222" data-mp="3okaordzvtivk" />
        <VolumesSection data-id="element-223" data-mp="3jkekrer6prg0" />
        <VisualSection data-id="element-224" data-mp="3jjn377uf9u8q" />
        <BonusesSection data-id="element-225" data-mp="3jj3mfugidbwa" />
        <BeforeAfterSection data-id="element-226" data-mp="3jmhkwrm1x0yg" />
        <AudienceSection data-id="element-227" data-mp="3fj33pxmdmejf" />
        <OfferSection data-id="element-228" data-mp="3fhrrrais20h8" />
        <OnePartSection data-id="element-229" data-mp="3fi9yx26z9z3x" />
        <FaqSection data-id="element-230" data-mp="3fl5reb023vkz" />
        <FinalSection data-id="element-231" data-mp="284zo6c2w11lf" />
      </main>

      <SiteFooter data-id="element-232" data-mp="28612cpf7a47d" />
    </div>;
}